import { Button, Divider, Grid, Typography, makeStyles } from "@material-ui/core"
import BadgeAvatars from "./BadgeAvatars"

import GainsShare from '../../assets/images/gains-share.svg';

const GAINS_LINK = 'https://twitter.com/GainsAssociates';

type LearnSocialProps = {
  projectName: string
  socialLink: string
  projectImage: string
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  details: {
    flexGrow: 1,
  },
  name: {
    fontSize: "17px",
    color: "rgba(17, 48, 45, 1)",
    lineHeight: "1.5rem",
    fontWeight: 400,
  },
  link: {
    fontSize: "14px",
    color: "rgba(17, 48, 45, 0.6)",
    lineHeight: "1rem",
    fontWeight: 400,
  },
  followButton: {
    marginLeft: 'auto',
  },
  divider: {
    width: "100%",
    // border: "1px solid rgba(0, 0, 0, 0.08)"
  },
}));

const LearnSocialSection = (props: LearnSocialProps) => {

  const classes = useStyles();
  const { projectName, socialLink, projectImage } = props;

  const handleClick = (socialLink: string) => {
    window.open(socialLink, '_blank')
  }

  return (
    <Grid container>
      <Grid container className={classes.root}>
        <Grid item>
          <BadgeAvatars src={projectImage} />
        </Grid>
        <Grid item className={classes.details}>
          <Grid container>
            <Grid item>
              <Typography variant="subtitle1" className={classes.name}>{projectName}</Typography>
              <Typography color="textSecondary" className={classes.link}>@{socialLink.split('/')[3]}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" className={classes.followButton} onClick={() => handleClick(socialLink)}>
            Follow
          </Button>
        </Grid>
      </Grid>
      <Divider className={classes.divider} />
      <Grid container className={classes.root}>
        <Grid item>
          <BadgeAvatars src={GainsShare} />
        </Grid>
        <Grid item className={classes.details}>
          <Grid container>
            <Grid item>
              <Typography variant="subtitle1" className={classes.name}>Gains Associates</Typography>
              <Typography color="textSecondary" className={classes.link}>@GainsAssociates</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" className={classes.followButton} onClick={() => handleClick(GAINS_LINK)}>
            Follow
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default LearnSocialSection;